import React from "react";
import "./MainPage.sass"
import {setActivePageSite} from "../../Redux/authReducer";
import {connect} from "react-redux";
import MainPage from "./MainPage";


class MainPageContainer extends React.Component {
    componentDidMount() {
        this.props.setActivePageSite("MAIN")
    }
    render() {
        return(
            <MainPage/>
        )
    }
}


let mapStateToProps = () => {
    return {

    }
};
export default connect(mapStateToProps, {setActivePageSite})(MainPageContainer)